/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { ServiceCardWrapper } from "../../styles/StyledComponents/ServiceCardWrapper";
import { WhoWeAreCompWrapper } from "../../styles/StyledComponents/WhoWeAreCompWrapper";
import { serviceData } from "../../ui/json/demo.mock";
import CommonHeading from "../CommonHeading/CommonHeading";
import ServiceCard from "./ServiceCard";

const WhoWeAreComp = () => {
  const [activeCard, setActiveCard] = useState<number | null>(0);

  const handleCardClick = (id: number) => {
    if (activeCard !== id) {
      setActiveCard(id);
    }
  };

  return (
    <WhoWeAreCompWrapper className="cmn_gap">
      <div className="container">
        <div className="row who_we_are_row">
          <div className="col_cmn col_left">
            <CommonHeading
              className="who_we_are_heading"
              alignText="left"
              isPrimary
              title="Who we are ?"
              paratext="We are a passionate team of designers, developers, and strategists
              committed to building beautiful, functional websites. With a focus
              on innovation and performance, we help businesses bring their
              digital vision to life."
            />
          </div>
          <div className="col_cmn col_right">
            <ServiceCardWrapper>
              <div className="row services_wraper">
                {serviceData?.map((item, index) => (
                  <ServiceCard
                    key={index}
                    {...item}
                    isActive={activeCard === index}
                    onClick={() => handleCardClick(index)}
                  />
                ))}
              </div>
            </ServiceCardWrapper>
          </div>
        </div>
      </div>
    </WhoWeAreCompWrapper>
  );
};

export default WhoWeAreComp;
